export default __webpack_public_path__ + "66670f2c1f5e7c4e531007e89bb85355.js";